import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/PublicLayout.vue'),
    children: [
      {
        path: '',
        name: 'landing',
        component: () => import('@/pages/LandingPage.vue'),
        meta: { transition: 'fade' }
      },
      {
        path: 'verdicts/shared/:token',
        name: 'verdict-shared',
        component: () => import('@/pages/VerdictSharedPage.vue'),
        meta: { transition: 'fade' }
      },
      {
        path: 'ui',
        name: 'ui-storybook',
        component: () => import('@/pages/UiKdsPage.vue'),
        meta: { transition: 'fade' }
      },
      {
        path: 'changelogs',
        name: 'changelogs',
        component: () => import('@/pages/ChangelogsPage.vue'),
        meta: { transition: 'fade' }
      },
      {
        path: 'docs',
        name: 'docs',
        component: () => import('@/pages/DocsPage.vue')
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('@/pages/AboutPage.vue')
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: () => import('@/pages/PrivacyPage.vue')
      },
      {
        path: 'terms',
        name: 'terms',
        component: () => import('@/pages/TermsPage.vue')
      },
      {
        path: 'cookies',
        name: 'cookies',
        component: () => import('@/pages/CookiesPage.vue'),
        meta: { layout: 'public' }
      },
      {
        path: 'legal-notice',
        name: 'legal-notice',
        component: () => import('@/pages/LegalNoticePage.vue'),
        meta: { layout: 'public' }
      },
      {
        path: 'status',
        name: 'status',
        component: () => import('@/pages/StatusPage.vue')
      },
      {
        path: 'configure-plan',
        name: 'configure-plan',
        component: () => import('@/pages/ConfigurePlanPage.vue'),
        meta: { transition: 'fade' }
      },
      {
        path: 'verdict-demo',
        name: 'verdict-demo',
        component: () => import('@/pages/VerdictDemoPage.vue'),
        meta: { transition: 'fade' }
      },
      {
        path: ':catchAll(.*)*',
        name: 'not-found',
        component: () => import('@/pages/NotFoundPage.vue'),
        meta: { status: 404, transition: 'fade' }
      }
    ]
  },
  {
    path: '/auth',
    component: () => import('@/layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name: 'auth',
        component: () => import('@/pages/AuthPage.vue'),
        meta: { transition: 'fade' }
      }
    ]
  },
  {
    path: '/app',
    component: () => import('@/layouts/AppLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/pages/DashboardPage.vue'),
        meta: { transition: 'fade' }
      },
      {
        path: 'personas',
        name: 'personas',
        component: () => import('@/pages/PersonasListPage.vue'),
        meta: { transition: 'slide-left' }
      },
      {
        path: 'personas/new',
        name: 'persona-new',
        component: () => import('@/pages/PersonaCreatePage.vue'),
        meta: { transition: 'slide-left' }
      },
      {
        path: 'personas/:id/edit',
        name: 'persona-edit',
        component: () => import('@/pages/PersonaEditPage.vue'),
        meta: { transition: 'slide-left' }
      },
      {
        path: 'personas/:id',
        name: 'persona-detail',
        component: () => import('@/pages/PersonaDetailPage.vue'),
        meta: { transition: 'slide-left' }
      },
      {
        path: 'projects',
        name: 'projects',
        component: () => import('@/pages/ProjectsListPage.vue'),
        meta: { transition: 'slide-left' }
      },
      {
        path: 'projects/:id',
        name: 'project-detail',
        component: () => import('@/pages/ProjectDetailPage.vue'),
        meta: { transition: 'slide-left' }
      },
      {
        path: 'debates',
        name: 'debate-list',
        component: () => import('@/pages/DebatesListPage.vue'),
        meta: { transition: 'slide-left' }
      },
      {
        path: 'debates/launch',
        name: 'debate-launch',
        component: () => import('@/pages/DebateLaunchPage.vue'),
        meta: { transition: 'slide-left' }
      },
      {
        path: 'debates/:id',
        name: 'debate-live',
        component: () => import('@/pages/DebateLivePage.vue'),
        meta: { transition: 'fade' }
      },
      {
        path: 'verdicts',
        name: 'verdicts',
        component: () => import('@/pages/VerdictsListPage.vue'),
        meta: { transition: 'fade' }
      },
      {
        path: 'verdicts/:id',
        name: 'verdict',
        component: () => import('@/pages/VerdictPage.vue'),
        meta: { transition: 'slide-left' }
      },
      {
        path: 'segments/new',
        name: 'segment-new',
        component: () => import('@/pages/SegmentNewPage.vue'),
        meta: { transition: 'fade' }
      },
      {
        path: 'segments/:id/assign',
        name: 'segment-assign',
        component: () => import('@/pages/SegmentAssignPage.vue'),
        meta: { transition: 'slide-left' }
      },
      {
        path: 'account',
        name: 'account',
        component: () => import('@/pages/AccountPage.vue'),
        meta: { transition: 'fade' }
      },
      {
        path: 'workspaces',
        name: 'workspaces',
        component: () => import('@/pages/ManageWorkspacesPage.vue'),
        meta: { transition: 'slide-left', requiresAuth: true }
      },
      {
        path: 'checkout-success',
        name: 'checkout-success',
        component: () => import('@/pages/CheckoutSuccessPage.vue'),
        meta: { transition: 'fade' }
      }
    ]
  },
];

export default routes;
